import axios from '../config/axios';
import { Collection, CreateCollectionRequest, UpdateCollectionRequest } from '../types/collection';

const COLLECTIONS_API = '/collections';

export const getCollections = async (): Promise<Collection[]> => {
  const { data } = await axios.get(COLLECTIONS_API);
  return data.sort((a: Collection, b: Collection) => a.order - b.order);
};

export const getCollectionById = async (id: string): Promise<Collection> => {
  const { data } = await axios.get(`${COLLECTIONS_API}/${id}`);
  return data;
};

export const createCollection = async (collection: CreateCollectionRequest): Promise<Collection> => {
  const { data } = await axios.post(COLLECTIONS_API, collection);
  return data;
};

export const updateCollection = async (id: string, updates: UpdateCollectionRequest): Promise<Collection> => {
  const { data } = await axios.put(`${COLLECTIONS_API}/${id}`, updates);
  return data;
};

export const deleteCollection = async (id: string): Promise<void> => {
  await axios.delete(`${COLLECTIONS_API}/${id}`);
};

export const toggleCollectionStatus = async (id: string, enabled: boolean): Promise<Collection> => {
  const { data } = await axios.patch(`${COLLECTIONS_API}/${id}/status`, { enabled });
  return data;
};

export const updateCollectionOrder = async (id: string, order: number): Promise<Collection> => {
  const { data } = await axios.patch(`${COLLECTIONS_API}/${id}/order`, { order });
  return data;
};

export const addProductToCollection = async (collectionId: string, productId: string): Promise<Collection> => {
  const { data } = await axios.post(`${COLLECTIONS_API}/${collectionId}/products`, { productId });
  return data;
};

export const removeProductFromCollection = async (collectionId: string, productId: string): Promise<Collection> => {
  const { data } = await axios.delete(`${COLLECTIONS_API}/${collectionId}/products/${productId}`);
  return data;
};

export const reorderCollections = async (collections: { id: string; order: number }[]): Promise<void> => {
  await axios.put(`${COLLECTIONS_API}/reorder`, collections );
}; 